/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import VideoProps from './properties/videoProps';

interface VideoPlayerParams {
  videoConfig: VideoProps;
  video: React.ReactNode;
  onNext: () => void;
  onPrev: () => void;
  allowPrev: boolean;
  allowNext: boolean;
}

const VideoPlayer = (params: VideoPlayerParams) => {
  const { videoConfig, video, onNext, onPrev, allowPrev, allowNext } = params;

  const isTriggerButton = (event: any) => {
    return ['Enter', ' '].indexOf(event.key) >= 0;
  };
  return (
    <div className="video-playlist__player">
      <div className="video-playlist__player-view">
        {video}
        {allowPrev && (
          <a
            className="video-navigator-btn ic-arrowLeft video-prev"
            onClick={onPrev}
            onKeyDown={(event) => {
              if (isTriggerButton(event)) {
                onPrev();
              }
            }}
            aria-label="vorheriges Video abspielen"
            role="button"
            tabIndex={0}
          />
          
        )}
        {allowNext && (
          <a
            className="video-navigator-btn ic-arrowRight video-next"
            onClick={onNext}
            onKeyDown={(event) => {
              if (isTriggerButton(event)) {
                onNext();
              }
            }}
            aria-label="nächstes Video abspielen"
            role="button"
            tabIndex={0}
          />
        )}
      </div>
      <div className="video-playlist__player__content">
        <h3 className="hl-h3">{videoConfig.headline}</h3>
        <p>{videoConfig.description}</p>
      </div>
    </div>
  );
};

export default VideoPlayer;
